import { render, staticRenderFns } from "./StockInversionSidebar.vue?vue&type=template&id=8712a552&scoped=true&"
import script from "./StockInversionSidebar.vue?vue&type=script&lang=js&"
export * from "./StockInversionSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8712a552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8712a552')) {
      api.createRecord('8712a552', component.options)
    } else {
      api.reload('8712a552', component.options)
    }
    module.hot.accept("./StockInversionSidebar.vue?vue&type=template&id=8712a552&scoped=true&", function () {
      api.rerender('8712a552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-inversion/components/StockInversionSidebar.vue"
export default component.exports